<div class="rag-cleanup-dialog">
    <app-popup-top-line></app-popup-top-line>
    <div class="rag-cleanup-dialog-header">
        <div class="title">
            Exclude From RAG
            <div class="description">
                Review files accessed by AI during the conversation, scan for risks, and exclude them from RAG if necessary.
            </div>
        </div>
        <img class="close-button" src="assets/images/common/cancel.svg" (click)="onClose()"/>
    </div>
    <div class="rag-cleanup-dialog-body">
        <app-prime-table
            #table
            class="table-component"
            queryParamProperty="finding"
            [data$]="filesCurrentPage$"
            [rowsPerPage]="50"
            [columns]="columns()"
            [isLoading]="(isLoading$ | async) === true"
            (rowSelected)="rowSelected($event)"
            (rowUnselected)="rowUnselected()"
            [withCheckboxSelection]="true"
            [withActions]="false"
            [tabelWithIcon]="false"
            [pageInfo]="pageInfo$.value"
            [sortedColumn$]="sortedColumn$"
            tableNotFoundText="No files found"
            (checkedRowsUpdate)="onCheckboxClick($event)"
            (multiCheckOnClick)="multiSelectedActionClick($event)"
            [checkedRowsSupportedActions$]="multiSelectedMenuActions$"
            tableNotFoundIcon="assets/images/common/no-results-found.svg"
        />
    </div>
    <br/><br/><br/>
    <div class="rag-cleanup-dialog-footer">
        <div class="rag-cleanup-dialog-buttons-container">
            <button
                class="rag-cleanup-dialog-button-hollowed"
                (click)="onExcludeClick()"
                [disabled]="checkedRows.size === 0"
                [ngClass]="{ 'rag-cleanup-dialog-button-disabled': checkedRows.size === 0 }">
                <span *ngIf="!waitingForResponse">EXCLUDE FROM RAG</span>
                <mat-progress-spinner class="spinner" *ngIf="waitingForResponse" color="primary" mode="indeterminate"></mat-progress-spinner>
            </button>
            <button
                class="rag-cleanup-dialog-button"
                [disabled]="checkedRows.size === 0"
                [ngClass]="{ 'rag-cleanup-dialog-button-disabled': checkedRows.size === 0 }">
                RESCAN
            </button>
        </div>
    </div>
</div>
